import { useMemo } from 'react';
import { getInfoByDomain } from 'utils/domainUtils';

const useComputedTitle = ({ hasTopNavMiddleAdornment, pageTitle, selectedLocation }) => {
    return useMemo(() => {
        const yard = selectedLocation?.yardName;
        const { text: baseTitle } = getInfoByDomain();

        if (yard && hasTopNavMiddleAdornment) return `${yard} | ${baseTitle}`;
        if (pageTitle) return `${pageTitle} | ${baseTitle}`;
        return baseTitle;
    }, [hasTopNavMiddleAdornment, pageTitle, selectedLocation?.yardName]);
};

export default useComputedTitle;
